var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { PUBLIC_APIS, USER_SERVICE_ENDPOINTS } from 'globals/apiEndPoints';
import { APIMethod } from 'globals/enums';
import { getChunks } from 'globals/global.functions';
import { uniq } from 'lodash';
export var loginUserService = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, API({
                        url: PUBLIC_APIS.LOGIN,
                        method: 'post',
                        data: data,
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                error_1 = _a.sent();
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export function resetPasswordService(param) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, API({
                    url: PUBLIC_APIS.RESET_PASSWORD,
                    method: 'post',
                    data: param,
                })];
        });
    });
}
/**
 * @function postUserMappingService
 * @description method to get senior data mapping
 * @param {string[]} userList list of users to fetch data for
 * @returns object of User Data
 */
export function postUserMappingService(userList) {
    return __awaiter(this, void 0, Promise, function () {
        var chunks, data, i, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chunks = getChunks(uniq(userList), 100);
                    data = {};
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < chunks.length)) return [3 /*break*/, 5];
                    return [4 /*yield*/, API({
                            url: USER_SERVICE_ENDPOINTS.GET_USER_MAPPING,
                            method: APIMethod.Post,
                            data: {
                                user_mapping: chunks[i],
                            },
                        })];
                case 3:
                    response = _a.sent();
                    data = __assign(__assign({}, data), response.data);
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, data];
                case 6:
                    error_2 = _a.sent();
                    throw error_2;
                case 7: return [2 /*return*/];
            }
        });
    });
}
/**
 * @function postValidatePasswordService
 * @description service to validate password of currentUser
 * @param {IValidatePasswordServiceParams} params
 */
export var postValidatePasswordService = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_3, errorMessage;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, API({
                        url: PUBLIC_APIS.VALIDATE_PASSWORD,
                        method: APIMethod.Post,
                        data: data,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, !!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.valid)];
            case 2:
                error_3 = _b.sent();
                errorMessage = error_3.response.data.message;
                throw new Error(errorMessage);
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * @function postChangePasswordService
 * @description service to validate password of currentUser
 * @param {IChangePasswordServiceData} data
 */
export var postChangePasswordService = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var error_4, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, API({
                        url: PUBLIC_APIS.CHANGE_PASSWORD,
                        method: APIMethod.Post,
                        data: data,
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2:
                error_4 = _a.sent();
                errorMessage = error_4.response.data.message;
                throw new Error(errorMessage);
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * @description api to service to resend otp if account is deactivated
 * @param {IGetResetPasswordServiceParams} params
 */
export var getResetPasswordService = function (params) { return __awaiter(void 0, void 0, Promise, function () {
    var error_5, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, API({
                        url: PUBLIC_APIS.RESET_PASSWORD,
                        method: APIMethod.Get,
                        params: params
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                errorMessage = error_5.response.data.message;
                throw new Error(errorMessage);
            case 3: return [2 /*return*/];
        }
    });
}); };
